import { render } from "./PageOverlay.vue?vue&type=template&id=56721d7c&scoped=true&ts=true"
import script from "./PageOverlay.vue?vue&type=script&lang=ts"
export * from "./PageOverlay.vue?vue&type=script&lang=ts"

import "./PageOverlay.vue?vue&type=style&index=0&id=56721d7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56721d7c"]])

export default __exports__